<template>
  <div class="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
    <form
      action="https://formsubmit.co/jimmyramjan@home.nl"
      method="POST"
      class="space-y-5 flex flex-col"
    >
      <div class="flex gap-5 md:gap-3 flex-col md:flex-row">
        <input
          type="text"
          id="firstName"
          class="w-full md:w-2/5 shadow-sm bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block p-2.5 placeholder-gray-400"
          placeholder="Voornaam"
          name="voornaam"
          required
        />
        <input
          type="text"
          id="middleName"
          class="w-full md:w-1/5 block p-3 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="tussenvoegsel"
          name="tussenvoegsel"
        />
        <input
          type="text"
          id="lastName"
          class="w-full md:w-2/5 block p-3 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="Achternaam"
          name="achternaam"
          required
        />
      </div>
      <div>
        <input
          type="text"
          id="address "
          class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 placeholder-gray-400"
          placeholder="Adres + huisnummer"
          name="adress"
          required
        />
      </div>
      <div>
        <input
          type="text"
          id="postalCode"
          class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="Postcode"
          name="postcode"
          required
        />
      </div>
      <div>
        <input
          type="text"
          id="city"
          class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="Woonplaats"
          name="woonplaats"
          required
        />
      </div>
      <div>
        <label for="birthDate" class="block mb-2 text-sm font-medium text-gray-400">Geboortedatum</label>
        <input
          type="date"
          id="birthDate"
          class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 placeholder-gray-400"
          placeholder="Geboortedatum"
          name="geboortedatum"
          required
        />
      </div>
      <div>
        <select
          id="package"
          name="geslacht"
          class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
        >
          <option value="">Geslacht</option>
          <option value="Man">Man</option>
          <option value="Vrouw">Vrouw</option>
          <option value="Anders">Anders</option>
        </select>
      </div>
      <div>
        <input
          type="email"
          id="email"
          name="email"
          class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="E-mail"
          required
        />
      </div>
      <div>
        <input
          type="tel"
          id="phoneNumber"
          name="telefoonnummer"
          class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="Telefoonnummer"
          required
        />
      </div>
      <div class="sm:col-span-2">
        <textarea
          id="message"
          rows="6"
          name="message"
          class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          placeholder="Vragen of opmerkingen"
        ></textarea>
      </div>
      <div class="flex gap-2">
        <input
          type="checkbox"
          id="terms"
          name="terms"
          class="block p-3 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 placeholder-gray-400"
          required
        />
        <label for="terms" class="text-sm text-gray-900 my-auto"
          >Ik ga akkoord met de
          <a href="/alegemeeneinfo" class="text-primary">algemene voorwarden</a>
          & <a href="/privacy" class="text-primary">privacyverklaring</a></label
        >
      </div>
      <button type="submit" class="button">Aanmelden</button>
    </form>
  </div>
</template>
